import { Controller } from "@hotwired/stimulus"

/**
 * Links a table row icon to the conversion action settings drawer.
 * Opens the drawer and auto-expands the destinations panel for the given CA.
 */
export default class extends Controller {
  static values = { drawerId: String, caId: String }

  open(event) {
    event.preventDefault()

    const drawerWrapper = document.getElementById(this.drawerIdValue)
    if (!drawerWrapper) return

    // Click the drawer's open button to trigger the drawer controller
    const openButton = drawerWrapper.querySelector('[data-action="drawer#open"]')
    if (openButton) openButton.click()

    // After drawer animation starts, expand destinations and scroll to the CA
    setTimeout(() => {
      const panel = drawerWrapper.querySelector(`[data-destinations-panel="${this.caIdValue}"]`)
      const chevron = drawerWrapper.querySelector(`[data-destinations-chevron="${this.caIdValue}"]`)

      if (panel && panel.classList.contains("hidden")) {
        panel.classList.remove("hidden")
      }
      if (chevron && !chevron.classList.contains("rotate-180")) {
        chevron.classList.add("rotate-180")
      }

      // Scroll to the conversion action in the drawer
      const checkbox = drawerWrapper.querySelector(`input[name="displayed_conversion_action_ids[]"][value="${this.caIdValue}"]`)
      if (checkbox) {
        const item = checkbox.closest("[data-list-filter-target='item']")
        if (item) item.scrollIntoView({ behavior: "smooth", block: "center" })
      }
    }, 350)
  }
}
